import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { SubscriptionsModuleState } from './store/index';
import * as fromRoot from './store/index';
import * as sub from './store/subscriptions.actions';
import { Subscription } from './store/subscriptions.model';
export class SubscriptionsLogicComponent implements OnInit {
  subscriptions$: Observable<Subscription[]>;
  isLoading$: Observable<boolean>;
/**
 * @param {?} store
 */
constructor(private store: Store<SubscriptionsModuleState>) {

    this.subscriptions$ = store.select(fromRoot.getSubscriptionsStateSubscriptions);
    this.isLoading$ = store.select(fromRoot. getSubscriptionsStateLoading);

  }
/**
 * @return {?}
 */
ngOnInit() {
    this.store.dispatch(new sub.LoadSubscription());
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'slb-subscriptions-logic',
  template: `
      <slb-subscriptions [subscriptions]="subscriptions$ | async" [loading]="isLoading$ | async"></slb-subscriptions>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Store, },
];
}

function SubscriptionsLogicComponent_tsickle_Closure_declarations() {
/** @type {?} */
SubscriptionsLogicComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SubscriptionsLogicComponent.ctorParameters;
/** @type {?} */
SubscriptionsLogicComponent.prototype.subscriptions$;
/** @type {?} */
SubscriptionsLogicComponent.prototype.isLoading$;
/** @type {?} */
SubscriptionsLogicComponent.prototype.store;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
